import React from "react";
import styled from "styled-components";
import { useServices } from "@core/servicesContext";
import { Carousel } from "@domain/carousel/carousel";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { getDisplayedAuthor } from "@domain/lms/utils";
import { InstructiveButton } from "@ui/components/instructiveButton";

interface CarouselActionProps extends React.HTMLAttributes<HTMLDivElement> {
	carousel: Carousel;
}

export const CarouselAction: React.FC<CarouselActionProps> = ({ carousel, ...htmlProps }) => {
	const { carouselService } = useServices();
	const currentProfile = useCurrentProfile();
	const displayedAuthor = getDisplayedAuthor(carousel);

	const subAuthor = displayedAuthor !== carousel.author ? carousel.author : undefined;
	const isAuthor = displayedAuthor.id === currentProfile?.id || subAuthor?.id === currentProfile?.id;

	return (
		<Container {...htmlProps}>
			<InstructiveButton
				content={carousel}
				isAuthor={isAuthor}
				isAuthenticated={!!currentProfile}
				toggleInstructive={() => carouselService.toggleInstructive(carousel)}
			/>
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;
